import {
  REQUEST_TOP_NAVIGATION,
  RECEIVE_TOP_NAVIGATION,
  RECEIVE_TOP_NAVIGATION_ERROR,
  OPEN_MOBILE_NAV,
  CLOSE_MOBILE_NAV,
  SET_MOBILE_NAV_LEVEL,
  UPDATE_LINKS,
} from 'apps/topNavigation/actions/topNavigation';
import { msg, config } from 'api';

export const initialState = {
  categories: {},
  groceryTopLevelCategoryIds: [],
  topTabs: [],
  navMenuLevel: 'root',
  mobileNavigationOpened: false,
  received: false,
  isFetching: false,
  currentUrl: '/',
  navMenuContents: {
    root: [
      {
        sectionId: 'SectionHome',
        sectionHeader: null,
        childrenIds: ['home'],
      }, {
        sectionId: 'SectionStartShopping',
        sectionHeader: 'Start Shopping',
        childrenIds: ['startShopping', 'mainSectionSupplements'],
      }, {
        sectionId: 'SectionAccount',
        sectionHeader: 'Your Account',
        childrenIds: ['account'],
      }, {
        sectionId: 'SectionFromScribe',
        sectionHeader: msg.nav.mainMobile.sectionFromScribeTitle,
        childrenIds: ['customMobileSection'],
      }, ...(
        config.mobileNavigation.corporateSection
      ),
    ],
    accountSettings: [
      {
        childrenIds: ['accountSettings'],
      },
    ],
  },
  links: {
    home: [
      { name: 'Home', url: '/' },
    ],
    customMobileSection: [],
    mainSectionSupplements: [],
    mainSectionReplacements: {},
  },
  subNavItemsByTabs: {},
  offersDropdown: {},
  headerInspirationDropdown: {},
  easyShoppingDropdown: {},
};

export default function topNavigation(state = initialState, action) {
  switch (action.type) {
    case REQUEST_TOP_NAVIGATION:
      return { ...state, isFetching: true };
    case RECEIVE_TOP_NAVIGATION: {
      return {
        ...state,
        isFetching: false,
        received: true,
        ...action.topNavigation,
        links: { ...state.links, ...action.topNavigation.links },
      };
    }
    case RECEIVE_TOP_NAVIGATION_ERROR: {
      return { ...initialState, error: action.error };
    }
    case OPEN_MOBILE_NAV: {
      return {
        ...state,
        mobileNavigationOpened: true,
        currentUrl: action.currentUrl,
      };
    }
    case CLOSE_MOBILE_NAV: {
      return { ...state, mobileNavigationOpened: false };
    }
    case SET_MOBILE_NAV_LEVEL: {
      return { ...state, navMenuLevel: action.level };
    }
    case UPDATE_LINKS: {
      return {
        ...state,
        links: {
          ...state.links,
          ...action.links,
        },
      };
    }
    default:
      return state;
  }
}
